module.exports = __webpack_public_path__ + "bariol_light-webfont.asset.c9dc9160abfca2885826a32f8ab74b8d.woff";